import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: true,
  selector: 'app-characteristic-consult-error-modal',
  imports: [CommonModule, B3DesignSystemWebModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './characteristic-consult-error-modal.component.html',
  styleUrls: ['./characteristic-consult-error-modal.component.scss'],
})
export class CharacteristicConsultErrorModalComponent {
  @ViewChild('errorModal') errorModal?: ElementRef<B3ModalElement>;

  @Input() open = false;
  @Input() message = 'Não foi possível concluir a operação. Tente novamente.';

  @Output() closed = new EventEmitter<void>();

  onDismiss(): void {
    this.closeModal();
  }

  onModalDismiss(): void {
    this.closeModal();
  }

  private closeModal(): void {
    const modalHost = this.errorModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    this.closed.emit();
  }
}
